import { createAPIModule } from 'utility/redux/apiModuleHelpers';

const getStateSlice = (state) => state.api.network.private.bulkAttachDetach;

const { actions, reducer, sagas, selectors } = createAPIModule({
	getStateSlice,
	actionType: 'NETWORK_PRIVATE_BULKATTACHDETACH',
	url: '/network/private/bulkAttachDetach.json',
});

export { actions, reducer, sagas, selectors };
